<div
  [ngClass]="{
    'card card-white auth-card': true,
    'auth-card-wide': wide
  }"
  style="margin:auto;"
>
  <div style="position: absolute;  right: 0;  top: 0;">
    <app-language-toggle colorName="primary"></app-language-toggle>
  </div>
  <div class="card-content ">
    <img
      class="mx-auto d-block"
      src="assets/images/kortojura_logo_full.png"
      height="100px"
    />
    <ng-content></ng-content>
  </div>
</div>
